export { default as Screen0 } from './Screen0/Screen0'
export { default as ScreenBuild } from './ScreenBuild/ScreenBuild'
export { default as ScreenStats } from './ScreenStats/ScreenStats'
export { default as ScreenScore } from './ScreenScore/ScreenScore'
export { default as ScreenGovern } from './ScreenGovern/ScreenGovern'
